var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoConfiguracin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.95,
    height: 19.949,
    viewBox: "0 0 17.95 19.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25457",
    "data-name": "Grupo 25457",
    transform: "translate(8 -615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25457-2",
    "data-name": "Grupo 25457",
    transform: "translate(-8 615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69297",
    "data-name": "Trazado 69297",
    d: "M173.992,170.667a3.325,3.325,0,1,0,3.325,3.325A3.325,3.325,0,0,0,173.992,170.667Zm0,4.987a1.662,1.662,0,1,1,1.662-1.662A1.662,1.662,0,0,1,173.992,175.654Z",
    transform: "translate(-165.017 -164.017)",
    fill: "#f8fbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69298",
    "data-name": "Trazado 69298",
    d: "M42.361,11.554l-.369-.213a7.565,7.565,0,0,0,0-2.735l.369-.213a2.5,2.5,0,1,0-2.494-4.322l-.37.214A7.462,7.462,0,0,0,37.129,2.92V2.494a2.494,2.494,0,1,0-4.987,0V2.92a7.461,7.461,0,0,0-2.367,1.368L29.4,4.073A2.5,2.5,0,1,0,26.909,8.4h0l.369.213a7.563,7.563,0,0,0,0,2.735l-.369.213A2.5,2.5,0,1,0,29.4,15.878h0l.37-.214a7.462,7.462,0,0,0,2.369,1.365v.426a2.494,2.494,0,1,0,4.987,0v-.426A7.461,7.461,0,0,0,39.5,15.661l.372.214a2.5,2.5,0,1,0,2.494-4.322h0ZM40.243,8.415a5.859,5.859,0,0,1,0,3.117.831.831,0,0,0,.386.942l.9.52a.832.832,0,0,1-.831,1.441h0l-.9-.522a.831.831,0,0,0-1.01.137,5.8,5.8,0,0,1-2.7,1.559.831.831,0,0,0-.624.805v1.042a.831.831,0,0,1-1.662,0V16.415a.831.831,0,0,0-.624-.805,5.805,5.805,0,0,1-2.695-1.562.831.831,0,0,0-1.01-.137l-.9.521A.831.831,0,0,1,27.732,13l.01-.005.9-.52a.831.831,0,0,0,.386-.942,5.858,5.858,0,0,1,0-3.117.831.831,0,0,0-.387-.938l-.9-.52a.832.832,0,0,1,.831-1.441l.9.522A.831.831,0,0,0,30.484,5.9a5.805,5.805,0,0,1,2.7-1.559.831.831,0,0,0,.624-.809V2.494a.831.831,0,1,1,1.662,0V3.534a.831.831,0,0,0,.624.805,5.805,5.805,0,0,1,2.7,1.562.831.831,0,0,0,1.01.137l.9-.521a.831.831,0,1,1,.841,1.434l-.01.006-.9.52a.831.831,0,0,0-.385.938Z",
    transform: "translate(-25.66)",
    fill: "#f8fbfd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoConfiguracin);
export default __webpack_public_path__ + "static/media/Icono-Configuración.48a227c51fb2d606ae44649cceac4423.svg";
export { ForwardRef as ReactComponent };